module.exports = __webpack_public_path__ + "fonts/Circe-Light.d59f216c.woff";